var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5Nocomments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 225,
    viewBox: "0 0 306 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.737 64.4819C293.737 64.4819 292.815 57.9394 290.982 53.1771L286.161 59.7297L293.742 64.4819H293.737Z",
    fill: "#FFF7D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.211 143.986C202.899 141.836 199.447 133.812 192.946 130.724C181.079 125.084 168.148 134.984 171.579 148.13C175.041 161.397 190.416 164.653 189.046 175.877C188.522 180.153 188.374 184.347 189.255 188.445H218.141L209.211 143.986Z",
    fill: "#D9D6E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5836 74.1125C91.3146 66.6672 104.485 72.099 104.582 83.9719C104.678 95.9513 94.2572 98.3654 97.9685 107.53C99.3838 111.019 101.191 119.479 96.8434 126.453L82.5836 117.192V74.1125Z",
    fill: "#F9F8F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.731 103.752C206.004 104.964 201.341 109.559 200.012 117.237C197.675 130.748 213.04 138.61 208.371 148.915C202.501 161.858 201.941 175.963 218.146 188.444L245.668 188.728V118.089C245.668 118.089 242.262 118.881 236.147 117.024C236.147 117.024 236.331 121.178 235.033 123.116C233.739 125.048 230.334 126.067 225.838 125.514L226.739 123.293C226.739 123.293 225.462 123.978 224.031 123.511L228.542 114.722C228.542 114.722 221.119 111.73 215.773 107.18L211.731 103.747V103.752Z",
    fill: "#F9F8F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.786 154.15C106.786 154.15 107.575 174.005 91.6712 188.729H82.5125V150.701C91.269 153.323 101.817 153.997 101.817 153.997L106.786 154.155V154.15Z",
    fill: "#EBEAF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.488 142.703C105.488 142.703 103.925 136.15 100.983 130.972C98.254 126.164 91.9259 118.161 82.5076 112.988V142.911C82.5076 142.911 95.4845 145.66 105.488 142.703Z",
    fill: "#EBEAF4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M228.542 114.722C221.766 112.379 211.915 106.217 205.368 95.1761C205.368 95.1761 229.163 93.9893 236.687 71.6078C236.687 71.6078 239.727 77.5874 242.547 80.7166V114.535L229.27 113.216L228.542 114.722Z",
    fill: "#FFF7D3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M237.726 43.1096V39.4478C226.989 40.5636 225.059 27.7829 225.059 27.7829C225.059 27.7829 201.626 37.2568 198.566 66.6322H224.031L237.726 43.1096Z",
    fill: "#FFF7D3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M167.048 66.6373L176.38 72.6169L171.467 80.899C171.467 80.899 176.639 82.8516 177.774 75.4012L179.734 74.7673L184.311 77.6987L166.89 104.68L152.029 95.1607C152.029 95.1607 154.799 94.0043 154.081 89.1912C154.081 89.1912 164.146 89.4854 163.25 83.0342L155.003 85.2962L167.053 66.6373H167.048Z",
    fill: "#DBD8E6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.532 69.5686C190.532 69.5686 189.066 74.5186 189.066 81.9487C189.066 89.3787 191.515 95.8807 194.727 95.8807C197.94 95.8807 200.389 89.7439 200.389 81.2589C200.389 72.7739 198.52 70.4054 198.52 70.4054L190.532 69.5686Z",
    fill: "#A49DC1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.918 115.214C144.918 115.214 147.183 119.251 150.671 123.05C154.158 126.849 160.298 130.916 162.568 128.244C164.839 125.566 161.112 117.72 156.5 112.531C151.887 107.338 146.959 104.934 146.959 104.934L144.923 115.219L144.918 115.214Z",
    fill: "#A49DC1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5078 112.982C80.6546 111.912 78.6081 110.898 76.3986 110C80.1354 120.032 79.7332 127.487 76.7244 131.053C73.5782 134.781 68.6705 132.711 68.6705 132.711C68.8945 136.165 68.1156 138.676 67.856 139.406L82.5078 142.905V112.982Z",
    fill: "#EBEAF4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2449 124.87C53.1837 125.489 51.0099 117.603 51.0099 117.603L49.0702 107.003C41.6272 108.392 33.9704 111.78 26.7158 118.09C6.88649 135.343 11.0051 159.394 11.0051 159.394L43.8774 133.685L61.6653 137.935C62.6987 131.175 60.2449 124.875 60.2449 124.875V124.87Z",
    fill: "#EBEAF4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M242.547 48.09C241.061 47.5929 239.569 46.893 238.495 44.9303C235.196 38.9102 239.513 32.5249 240.893 24.0855C242.272 15.6462 240.745 8.29222 240.745 8.29222C240.745 8.29222 240.348 13.7088 238.627 14.992C236.907 16.2751 234.565 15.773 231.953 14.8195C228.883 13.6987 225.36 12.5423 220.946 14.0435C220.946 14.0435 226.154 -3.05176e-05 239.63 -3.05176e-05C244.92 -3.05176e-05 248.499 2.16052 251.818 5.79694C255.422 9.7478 258.054 11.741 262.529 12.4155C267.004 13.0901 272.564 16.6048 274.193 21.9402C275.822 27.2757 278.398 29.3043 284.497 32.3677C290.601 35.431 292.632 41.3294 292.632 47.0046C292.632 52.6799 289.761 62.1437 277.578 61.459C266.129 60.8149 261.435 52.1271 262.524 44.8999L242.547 32.3677V48.09Z",
    fill: "#0E090C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5397 124.551C59.5164 122.71 58.6204 121.204 58.6204 121.204C58.6204 121.204 57.7855 123.699 54.9142 121.883C52.0429 120.062 50.4749 115.691 52.4604 114.336C54.4458 112.982 57.368 116.872 57.368 116.872C55.9018 110.446 51.5694 106.891 51.5694 106.891C51.5694 106.891 55.5251 107.241 57.4953 106.12C62.2299 103.422 60.2393 99.9531 66.9951 99.8009C73.7508 99.6488 75.441 92.802 71.358 88.5265C67.2751 84.2511 62.4896 86.7058 60.9215 88.5265C59.3484 90.3473 57.7091 91.5391 55.3877 92.2441C53.0662 92.944 48.4232 92.807 46.6617 95.8196C44.9003 98.8322 45.4654 101.987 46.8705 104.163C48.2756 106.333 48.2094 108.296 47.013 109.909C45.8166 111.522 44.3403 113.342 44.269 115.305C44.1977 117.268 45.3228 118.602 47.7003 119.023C50.0778 119.444 50.6683 121.056 51.0909 121.883C51.5134 122.71 52.0785 126.311 55.7288 126.945C57.3019 127.219 59.7557 126.509 60.3055 124.652L60.5346 124.556L60.5397 124.551Z",
    fill: "#0E090C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M245.668 118.09C245.668 118.09 259.103 118.526 270.339 111.618L264.041 104.928H245.663V118.09H245.668Z",
    fill: "#FFF7D3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1527 64.4617C101.644 64.4617 108.527 57.6043 108.527 49.1452C108.527 40.686 101.644 33.8286 93.1527 33.8286C84.6615 33.8286 77.778 40.686 77.778 49.1452C77.778 57.6043 84.6615 64.4617 93.1527 64.4617Z",
    fill: "#FFF7D3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M224.423 14.8499C224.423 14.8499 223.064 21.0424 225.421 29.1268C227.712 36.9828 232.477 39.9346 236.387 39.3868",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M230.207 21.94L229.591 27.7877H231.637",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M236.535 20.4695C236.535 20.4695 235.216 22.6605 233.546 20.4898",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M228.338 21.0323C228.338 21.0323 227.147 23.1472 225.772 20.9005",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M245.668 177.743L213.839 116.873",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M234.763 132.052L227.941 143.844",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M237.629 162.371L215.127 163.599",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M204.609 164.197L185.177 142.586",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M198.749 158.318L189.066 157.999",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M191.22 149.306L191.749 140.938",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5836 100.633L91.8441 82.3698",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.549 97.0774L92.6436 94.6176",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2755 89.4093L85.9235 82.4661",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M210.367 180.806L199.513 182.16",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M286.161 59.7296L293.737 64.4818",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M226.744 123.294C225.405 124.019 224.036 123.512 224.036 123.512L229.275 113.307L242.552 114.54V32.368L262.529 44.9002",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M230.736 113.439L225.838 125.51C225.838 125.51 230.67 126.362 233.887 124.257C235.511 123.192 236.143 121.219 236.143 117.38",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M232.701 113.622L228.919 125.682",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M234.763 113.814L232.33 125.028",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M129.579 188.729H82.5077",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M218.146 188.444C218.146 188.444 210.184 183.383 206.141 173.219",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M245.668 104.928V127.325",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M242.547 104.928H275.873L248.264 40.8625",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M237.726 43.1097L224.031 66.6323H174.41L172.908 69.087",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M194.727 66.6323C197.853 66.6323 200.389 73.1799 200.389 81.2541",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M142.494 103.752C141.241 107.667 143.532 114.443 148.623 120.727",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M198.52 70.4002L182.789 68.757C182.789 68.757 183.721 74.2547 177.775 75.3959C177.775 75.3959 176.914 82.6078 171.467 80.8936L177.989 69.8981",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M264.041 104.928C266.108 107.135 267.951 109.092 270.338 111.618",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M236.148 49.1448C236.148 49.1448 233.052 57.006 235.043 65.9829C236.056 70.5576 237.431 74.0977 242.547 80.7112",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M194.727 95.8806C210.871 95.8806 228.72 91.8892 236.147 72.8956",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M236.148 117.025C239.401 117.72 242.781 118.09 246.243 118.09C272.68 118.09 294.113 96.7379 294.113 70.4004C294.113 68.3971 293.991 66.4192 293.747 64.4818C293.441 62.0423 292.953 59.6586 292.296 57.3459",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M177.169 158.156C177.011 158.552 176.859 158.942 176.711 159.338",
    stroke: "#EA5599",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M175.896 161.721C174.588 165.875 173.845 170.191 173.529 175.03C171.783 201.996 189.061 222.699 219.531 223.956C246.63 225.077 271.785 204.441 268.633 172.047C266.571 148.393 267.508 137.108 278.291 126.787C287.287 118.176 298.39 118.374 303.267 118.982",
    stroke: "#EA5599",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M304.525 119.17C305.324 119.307 305.772 119.419 305.772 119.419",
    stroke: "#EA5599",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M143.777 145.883C143.874 156.092 140.494 168.69 128.291 175.238",
    stroke: "#EA5599",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M155.293 82.1565H149.24C149.24 82.1565 149.082 82.9527 141.578 106.648C134.074 130.343 111.088 149.59 81.8711 142.911C52.6591 136.231 43.8772 133.685 43.8772 133.685L0.772003 167.397",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M162.568 128.238C162.568 128.238 135.672 165.328 82.5125 150.696V188.724",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8301 143.245L20.9579 183.378",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M183.558 120.656C188.569 120.656 192.631 116.61 192.631 111.618C192.631 106.627 188.569 102.581 183.558 102.581C178.548 102.581 174.486 106.627 174.486 111.618C174.486 116.61 178.548 120.656 183.558 120.656Z",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M121.158 99.086C124.743 99.086 127.649 96.1909 127.649 92.6196C127.649 89.0483 124.743 86.1531 121.158 86.1531C117.573 86.1531 114.667 89.0483 114.667 92.6196C114.667 96.1909 117.573 99.086 121.158 99.086Z",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M31.557 142.048C31.557 142.048 14.2783 133.442 14.2783 108.271C14.2783 91.1689 24.4653 78.9765 39.8298 72.8955C57.7704 65.79 73.0585 70.3901 84.1569 62.1079C95.2552 53.8258 94.9344 39.6403 91.1264 32.6413C87.3693 25.7336 78.6739 19.2266 67.3618 21.94C57.0526 24.415 50.867 32.3877 49.9659 40.8625",
    stroke: "#EA5599",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5077 112.541V72.8956",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M150.487 86.5337L163.25 83.0342C163.25 83.0342 165.042 88.9022 154.082 89.1912C154.082 89.1912 155.589 95.9823 148.746 95.8808L144.918 115.214",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7341 136.738L58.4068 145.314L64.8469 138.944L66.9546 147.125L74.3008 141.161",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8467 138.945C64.8467 138.945 64.6838 142.982 62.342 146.299C60.0001 149.615 59.1652 152.816 60.1478 157.999C61.1303 163.182 60.9063 168.249 56.8946 172.54C52.883 176.83 51.6713 181.03 52.5826 188.734C53.4888 196.432 51.9768 200.748 47.4356 205.414C42.8945 210.08 42.2887 214.98 42.365 217.693",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M201.657 55.5707C201.657 55.5707 218.523 53.9731 219.134 35.8671C219.684 19.4094 204.91 14.8499 199.895 14.8499C186.99 14.8499 178.085 23.8928 177.271 35.2128C176.456 46.5329 184.587 51.1837 191.088 45.3157C197.589 39.4528 195.288 26.525 193.664 20.4694C192.096 14.6217 187.366 4.91442 175.947 0.461456",
    stroke: "#EA5599",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4122 118.734L74.917 117.562L70.6559 110.497",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6559 110.498C70.6559 110.498 71.4653 107.637 74.4537 108.925",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3413 111.623C67.3413 111.623 64.2715 109.25 62.4896 114.037",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7691 139.635C67.7691 139.635 69.0571 136.424 68.5531 132.661",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6295 138.174C61.6295 138.174 62.9786 131.621 59.9189 123.942C61.8433 127.508 65.8906 133.285 71.8878 133.285C80.5577 133.285 82.1257 119.398 71.8878 99.796",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M153.959 92.6346L170.82 88.0346L167.481 69.0867",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6716 188.728C91.6716 188.728 88.1028 192.319 82.513 195.398C75.6707 199.166 67.3877 201.661 58.7331 201.661C35.5335 201.661 16.1726 185.28 11.6671 163.497",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M63.065 152.877C63.6948 152.877 64.2053 152.368 64.2053 151.741C64.2053 151.113 63.6948 150.605 63.065 150.605C62.4352 150.605 61.9246 151.113 61.9246 151.741C61.9246 152.368 62.4352 152.877 63.065 152.877Z",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M55.734 181.329C56.3638 181.329 56.8743 180.82 56.8743 180.193C56.8743 179.566 56.3638 179.057 55.734 179.057C55.1042 179.057 54.5936 179.566 54.5936 180.193C54.5936 180.82 55.1042 181.329 55.734 181.329Z",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5603 213.666C47.1901 213.666 47.7007 213.158 47.7007 212.53C47.7007 211.903 47.1901 211.394 46.5603 211.394C45.9305 211.394 45.4199 211.903 45.4199 212.53C45.4199 213.158 45.9305 213.666 46.5603 213.666Z",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4534 123.329C74.4534 123.329 69.9072 124.166 68.217 122.862",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9462 112.775C66.427 112.775 66.8168 112.386 66.8168 111.907C66.8168 111.429 66.427 111.04 65.9462 111.04C65.4654 111.04 65.0757 111.429 65.0757 111.907C65.0757 112.386 65.4654 112.775 65.9462 112.775Z",
    fill: "#0E090C"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0535 110.411C73.5343 110.411 73.9241 110.023 73.9241 109.544C73.9241 109.065 73.5343 108.677 73.0535 108.677C72.5727 108.677 72.183 109.065 72.183 109.544C72.183 110.023 72.5727 110.411 73.0535 110.411Z",
    fill: "#0E090C"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M230.614 31.4497C230.614 31.4497 233.913 31.683 235.043 30.7448",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M213.371 188.445H229.753",
    stroke: "#0E090C",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M178.655 107.18C178.655 107.18 186.068 120.656 180.992 136.358C178.854 142.971 169.716 162.371 140.061 158.313C129.721 156.898 120.517 150.498 116.352 141.734C110.711 129.861 115.135 119.271 123.907 118.729C127.053 118.536 130.108 119.566 132.832 121.452",
    stroke: "#EA5599",
    strokeWidth: 0.446154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Nocomments);
export default __webpack_public_path__ + "static/media/5nocomments.a38d8a173ed7d1b1bfc6fbaa346083e5.svg";
export { ForwardRef as ReactComponent };